import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useDeviceType } from '@cars4ever/public-ui';

import styles from './styles.module.scss';

export interface IWidgetLayoutProviderProps {
  children: ReactNode;
}

const WidgetLayoutProvider = ({ children }: IWidgetLayoutProviderProps): ReactElement => {
  const { isDesktop } = useDeviceType();

  useEffect(
    (): (() => void) | void => {
      if (window.xprops.isWidgetMode) {
        document.documentElement.classList.add(styles.widgetLayout);
      }

      if (isDesktop) {
        return;
      }

      void window.xprops.autoCalculateSpacers();
    },
    [isDesktop],
  );

  return (
    <>
      {children}
    </>
  );
};

export default WidgetLayoutProvider;
